module.exports = __webpack_public_path__ + "images/banners/guidance_slider_modal/sp_082f552584642f1aaa9d05ed152d90b5.webp";